<template>
  <div class="UiSpinner" :class="{ 'UiSpinner--tinting': tinting }" :style="styles">
    <Icon :name="icon" class="UiSpinner__spinner" />
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import Icon from './Icon.vue';

  const props = withDefaults(defineProps<{
    icon?: string;
    width?: string | number;
    height?: string | number;
    tinting?: boolean;
  }>(), {
    icon: 'loader',
    width: '100%',
    height: '100%',
  });

  const styles = computed<{ width: string; height: string }>(() => ({
    width: String(props.width),
    height: String(props.height),
  }));
</script>

<style lang="scss" scoped>
  // region REMOVE_ME
  $color-primary: #ff0d29;
  $color-white: #ffffff;

  // endregion REMOVE_ME

  @keyframes circle {
    0% {
      transform: rotate(0);
    }

    50% {
      transform: rotate(180deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  .UiSpinner {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;

    &--tinting {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 3;
      background: rgba($color-white, 0.5);
    }

    &__spinner {
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 100%;
      height: 100%;
      max-width: 64px;
      max-height: 64px;
      margin-bottom: auto;
      margin-top: auto;
      animation-name: circle;
      animation-duration: 1200ms;
      animation-timing-function: linear;
      animation-iteration-count: infinite;
    }
  }
</style>
